@if (errorMessage) {
  <div class="rejected-files-message">
    <mat-icon alt="Warning!" class="warning-icon" svgIcon="k12-warning"> </mat-icon>
    <p aria-labelledby="Error Message Display">
      {{ errorMessage }}
    </p>
    <button
      aria-labelledby="Close/Cancel Message Action"
      class="close-error-button"
      data-pw="close_error_msg"
      data-qa="close_error_msg"
      mat-icon-button
      matTooltip="Close"
      (click)="clearErrorMessage()"
      (keyup)="($event.key === 'Enter' || $event.key === ' ') && clearErrorMessage()"
      tabindex="0">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<div class="document">
  <div class="document__container">
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (task && taskAction) {
      <lib-task-header-info [task]="task" [taskTypeAction]="taskTypeAction" [recentTaskNote]="recentTaskNote">
        @if (contextItems.length > 0) {
          @for (item of contextItems; track item.label) {
            <div class="upload-context__row">
              <span class="task__information-label">{{ item.label }}:</span>
              <span class="task__information-value">{{ item.value }}</span>
            </div>
          }
          @if (fileDocumentType) {
            <div class="upload-context__row">
              <span class="task__information-label">Required Document:</span>
              <span class="task__information-value">{{ fileDocumentType }}</span>
            </div>
          }
        }
        @if (taskTypeAction?.uploadDocumentAcceptableFileExtensions) {
          <div>
            <span aria-labelledby="Accepted Formats Instructions Header" class="task__information-label sm">
              Accepted Formats:
            </span>
            <span aria-labelledby="Accepted Format Types" class="task__information-value sm">
              {{ taskTypeAction.uploadDocumentAcceptableFileExtensions.split(',') }}
            </span>
            <span aria-labelledby="Maximum File Size Header" class="task__information-label ml-2 sm">
              Maximum file size:
            </span>
            <span aria-labelledby="Maximum File Size in Megabytes" class="task__information-value sm">
              {{ taskTypeAction.uploadDocumentMaxSizeMegabytes }}mb
            </span>
          </div>
        }
      </lib-task-header-info>

      <lib-cfi-file-upload [configJson]="promptComponent!" [isEnabled]="true" (filesAdded)="onFilesAdded($event)">
      </lib-cfi-file-upload>

      <div class="button-row">
        <button
          aria-labelledby="Go Back Action"
          class="back-btn xlarge_button secondary_materials_button"
          color="primary"
          data-qa="upload_back_button"
          data-pw="upload_back_button"
          mat-stroked-button
          (click)="onBack()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()">
          <svg fill="none" height="14" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg" alt="Back">
            <path
              d="M0.381836 6.38213C0.0400391 6.72393 0.0400391 7.279 0.381836 7.6208L5.63184 12.8708C5.97363 13.2126 6.52871 13.2126 6.87051 12.8708C7.2123 12.529 7.2123 11.9739 6.87051 11.6321L2.23848 7.0001L6.86777 2.36807C7.20957 2.02627 7.20957 1.47119 6.86777 1.12939C6.52598 0.787598 5.9709 0.787598 5.6291 1.12939L0.379102 6.37939L0.381836 6.38213Z"
              fill="#003D57" />
          </svg>
          Back
        </button>
        <button
          aria-labelledby="Submit Upload Action"
          class="submit-btn primary_materials_button xlarge_button top-margin"
          data-pw="upload_submit_button"
          data-qa="upload_submit_button"
          mat-stroked-button
          color="accent"
          [disabled]="!hasFiles"
          (click)="onSubmit()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onSubmit()">
          Submit
          <svg fill="none" height="14" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg" alt="submit">
            <path
              d="M7.66257 6.4468C7.96723 6.75145 7.96723 7.24409 7.66257 7.5455L1.43981 13.7715C1.13516 14.0762 0.642523 14.0762 0.341108 13.7715C0.039693 13.4669 0.036452 12.9742 0.341108 12.6728L6.0129 7.00101L0.337867 1.32598C0.033211 1.02133 0.033211 0.528693 0.337867 0.227278C0.642523 -0.0741368 1.13516 -0.0773778 1.43657 0.227278L7.66257 6.4468Z"
              [attr.fill]="!hasFiles ? '#C2C2C3' : 'white'" />
          </svg>
        </button>
      </div>
    }
  </div>
</div>
